<div class="card card-body">
    <div class="row">
        <div class="col-lg-12">
            <div class="icon-head">
                <svg xmlns="http://www.w3.org/2000/svg" width="100px" height="100px" fill="currentColor"
                    class="bi bi-person-circle icon-increase" viewBox="0 0 20 20">
                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                    <path fill-rule="evenodd"
                        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
                </svg>
            </div>
        </div>
    </div>
    <div class="row font mt-2">
        <div class="col-lg-12">
            <table class="table common-table">
                <tr>
                    <th class="text-right">User Name :</th>
                    <td class="text-left">{{user.userName}}</td>
                </tr>
                <tr>
                    <th class="text-right">Entity Code :</th>
                    <td class="text-left">{{user.entityCode}}</td>
                </tr>
                <tr>
                    <th class="text-right">Entity Type :</th>
                    <td class="text-left">{{user.entityType}}</td>
                </tr>
                <tr>
                    <th class="text-right">Email Id :</th>
                    <td class="text-left">{{user.emailId}}</td>
                </tr>
                <tr>
                    <th class="text-right">Mobile Number :</th>
                    <td class="text-left">{{user.userMobile}}</td>
                </tr>
            </table>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-3" *ngIf="user.entityType!='ADMIN'">
            <button class="btn btn-primary full-width" type="button" routerLink="/settings/accessMapping">Access
                Details</button>
        </div>
        <div class="col-lg-3" *ngIf="user.entityType!='ADMIN'">
            <button class="btn btn-primary full-width" type="button" (click)="changePassword()">Change Password</button>
        </div>
        <div class="col-lg-3">
            <button class="btn btn-secondary full-width" type="button" routerLink="">Back</button>
        </div>
    </div>
</div>